import { whereToFilter } from "@contember/client";
import { TreeNodeUtils } from "../utils/TreeNodeUtils.js";
import { QueryLanguage } from "../queryLanguage/QueryLanguage.js";
class TreeNodeEnvironmentFactory {
  static createEnvironmentForEntityListSubtree(environment, sugaredEntityList) {
    let entityList;
    let rootWhere;
    let expectedCardinality;
    if (sugaredEntityList.isCreating) {
      entityList = QueryLanguage.desugarUnconstrainedQualifiedEntityList(sugaredEntityList, environment);
      rootWhere = {};
      expectedCardinality = "zero";
    } else {
      entityList = QueryLanguage.desugarQualifiedEntityList(sugaredEntityList, environment);
      rootWhere = entityList.filter ?? {};
      expectedCardinality = "zero-to-many";
    }
    const entitySchema = TreeNodeUtils.resolveEntity(environment.getSchema(), entityList.entityName, "entity list");
    return environment.withSubTree({
      type: "subtree-entity-list",
      entity: entitySchema,
      expectedCardinality,
      filter: rootWhere
    });
  }
  static createEnvironmentForEntitySubtree(environment, sugaredEntityList) {
    let entity;
    let rootWhere;
    let expectedCardinality;
    if (sugaredEntityList.isCreating) {
      rootWhere = {};
      expectedCardinality = "zero";
      entity = QueryLanguage.desugarUnconstrainedQualifiedSingleEntity(sugaredEntityList, environment);
    } else {
      entity = QueryLanguage.desugarQualifiedSingleEntity(sugaredEntityList, environment, { missingSetOnCreate: "fill" });
      rootWhere = whereToFilter(entity.where);
      expectedCardinality = entity.setOnCreate ? "zero-or-one" : "one";
    }
    const entitySchema = TreeNodeUtils.resolveEntity(environment.getSchema(), entity.entityName, "entity");
    return environment.withSubTree({
      type: "subtree-entity",
      entity: entitySchema,
      expectedCardinality,
      filter: rootWhere
    });
  }
  static createEnvironmentForEntityList(environment, sugaredRelativeEntityList) {
    const relativeEntityList = QueryLanguage.desugarRelativeEntityList(sugaredRelativeEntityList, environment);
    const hasOneEnvironment = this.traverseHasOnePath(environment, relativeEntityList.hasOneRelationPath);
    const hasManyField = relativeEntityList.hasManyRelation.field;
    const field = TreeNodeUtils.resolveHasManyRelation(hasOneEnvironment, hasManyField);
    const targetEntity = environment.getSchema().getEntity(field.targetEntity);
    return hasOneEnvironment.withSubTreeChild({
      type: "entity-list",
      field,
      entity: targetEntity
    });
  }
  static createEnvironmentForEntity(environment, sugaredRelativeSingleEntity) {
    const relativeSingleEntity = QueryLanguage.desugarRelativeSingleEntity(sugaredRelativeSingleEntity, environment);
    return this.traverseHasOnePath(environment, relativeSingleEntity.hasOneRelationPath);
  }
  static createEnvironmentForField(environment, sugaredRelativeSingleField) {
    const relativeSingleField = QueryLanguage.desugarRelativeSingleField(sugaredRelativeSingleField, environment);
    const hasOneEnvironment = this.traverseHasOnePath(environment, relativeSingleField.hasOneRelationPath);
    const field = TreeNodeUtils.resolveColumn(hasOneEnvironment, relativeSingleField.field);
    return hasOneEnvironment.withSubTreeChild({
      type: "column",
      entity: environment.getSubTreeNode().entity,
      field
    });
  }
  static traverseHasOnePath(environment, hasOneRelationPath) {
    for (const pathItem of hasOneRelationPath) {
      const field = TreeNodeUtils.resolveHasOneRelation(environment, pathItem.field, !!pathItem.reducedBy);
      const targetEntity = environment.getSchema().getEntity(field.targetEntity);
      environment = environment.withSubTreeChild({
        type: "entity",
        field,
        entity: targetEntity
      });
    }
    return environment;
  }
}
export {
  TreeNodeEnvironmentFactory
};
//# sourceMappingURL=TreeNodeEnvironmentFactory.js.map
